import Icon from '../components/Icon.vue'

Icon.register({
  backspace: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M576 64H205.3A64-64 0 0 1 160 82.8L9.4 233.4C-3.1 245.9-3.1 266.1 9.4 278.6L160 429.3C172 441.3 188.3 448 205.3 448H576C611.4 448 640 419.4 640 384V128C640 92.6 611.4 64 576 64zM491.3 318.1C497.6 324.3 497.6 334.4 491.3 340.7L468.7 363.3C462.4 369.6 452.3 369.6 446.1 363.3L384 301.3 321.9 363.3C315.7 369.6 305.6 369.6 299.3 363.3L276.7 340.7C270.4 334.4 270.4 324.3 276.7 318.1L338.8 256 276.7 193.9C270.4 187.7 270.4 177.6 276.7 171.3L299.3 148.7C305.6 142.4 315.7 142.4 321.9 148.7L384 210.8 446.1 148.7C452.3 142.4 462.4 142.4 468.7 148.7L491.3 171.3C497.6 177.6 497.6 187.7 491.3 193.9L429.3 256 491.3 318.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/backspace.js
// module id = WuWE
// module chunks = 144